// Mock data for Care Pharmacy website

// Featured Care Pharmacy stores across India
export const featuredStores = [
  { id: 1, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'Sola', region: 'Gujarat' },
  { id: 2, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'Maninagar', region: 'Gujarat' },
  { id: 3, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'Science City', region: 'Gujarat' },
  { id: 4, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'South Bopal', region: 'Gujarat' },
  { id: 5, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'Shela', region: 'Gujarat' },
  { id: 6, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'Naroda', region: 'Gujarat' },
  { id: 7, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'Ranip', region: 'Gujarat' },
  { id: 8, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'Nikol', region: 'Gujarat' },
  { id: 9, name: 'Care Pharmacy', city: 'Ahmedabad', state: 'Gujarat', location: 'Sabarmati', region: 'Gujarat' },
  { id: 10, name: 'Care Pharmacy', city: 'Gandhinagar', state: 'Gujarat', location: 'PDPU', region: 'Gujarat' },
  { id: 11, name: 'Care Pharmacy', city: 'Gandhinagar', state: 'Gujarat', location: 'Raisan', region: 'Gujarat' },
  { id: 12, name: 'Care Pharmacy', city: 'Visnagar', state: 'Gujarat', location: 'Bus Stand', region: 'Gujarat' },
  { id: 13, name: 'Care Pharmacy', city: 'Mehsana', state: 'Gujarat', location: 'Radhanpur Cross Road', region: 'Gujarat' },
  { id: 14, name: 'Care Pharmacy', city: 'Vijapur', state: 'Gujarat', location: 'T.B. Road', region: 'Gujarat' },
  { id: 15, name: 'Care Pharmacy', city: 'Patan', state: 'Gujarat', location: 'Bus Stand', region: 'Gujarat' }
];

// Store presence by state with counts
export const storePresence = [
  { state: 'Gujarat', count: 108, lat: 23.0225, lng: 72.5714, cities: ['Ahmedabad', 'Gandhinagar', 'Mehsana', 'Surat', 'Vadodara', 'Rajkot'] },
  { state: 'Madhya Pradesh', count: 52, lat: 22.7196, lng: 75.8577, cities: ['Indore', 'Bhopal', 'Ujjain', 'Dewas', 'Guna', 'Dhar'] },
  { state: 'Maharashtra', count: 8, lat: 19.0760, lng: 72.8777, cities: ['Mumbai', 'Pune', 'Satara', 'Ahmednagar'] },
  { state: 'Delhi', count: 4, lat: 28.6139, lng: 77.2090, cities: ['Delhi', 'Ghaziabad', 'Gurugram'] },
  { state: 'Uttar Pradesh', count: 4, lat: 26.8467, lng: 80.9462, cities: ['Lucknow', 'Agra', 'Mujaffarnagar'] },
  { state: 'Karnataka', count: 2, lat: 12.9716, lng: 77.5946, cities: ['Bangalore'] },
  { state: 'Telangana', count: 3, lat: 17.3850, lng: 78.4867, cities: ['Hyderabad', 'Kurnul'] },
  { state: 'Odisha', count: 4, lat: 20.2961, lng: 85.8245, cities: ['Bhubaneshwar', 'Dhenkanal'] },
  { state: 'Others', count: 9, lat: 23.6102, lng: 85.2799, cities: ['Assam', 'Jharkhand', 'Goa', 'Rajasthan', 'Chhattisgarh'] }
];

export const storeLocations = featuredStores;

export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Patel',
    location: 'Ahmedabad',
    text: 'Care Pharmacy has become my go-to for all medical needs. The 20% discount on medicines is genuine, and their staff is knowledgeable and helpful.'
  },
  {
    id: 2,
    name: 'Dr. Priya Sharma',
    location: 'Mumbai',
    text: 'As a physician, I recommend Care Pharmacy to my patients. They maintain excellent stock of medicines and provide reliable home delivery service.'
  },
  {
    id: 3,
    name: 'Amit Kumar',
    location: 'Delhi',
    text: 'The franchise model is transparent and well-structured. Care Pharmacy provided complete support from site selection to launch.'
  },
  {
    id: 4,
    name: 'Meera Desai',
    location: 'Pune',
    text: 'I order through WhatsApp and medicines arrive promptly with digital receipts. Very convenient for my elderly parents.'
  }
];

export const services = [
  {
    id: 1,
    title: 'Prescription Medicines',
    description: 'Branded, ethical & generics; specialty & imported products with assured availability.',
    icon: 'pill'
  },
  {
    id: 2,
    title: 'OTC & Wellness',
    description: 'Vitamins, nutraceuticals, health foods & personal care products for daily wellness.',
    icon: 'heart'
  },
  {
    id: 3,
    title: 'Surgical & Medical Supplies',
    description: 'Hospital & home-care essentials including wound care, mobility aids, and diagnostics.',
    icon: 'stethoscope'
  },
  {
    id: 4,
    title: 'Diagnostics Tie-ups',
    description: 'Sample collection with reputed partners like Dr. Lal Path, Metropolis & Sterling Accuris.',
    icon: 'activity'
  },
  {
    id: 5,
    title: 'In-store Doctor Desk',
    description: 'Select locations feature OPD for basic consultations and health guidance.',
    icon: 'user-round-check'
  },
  {
    id: 6,
    title: 'Home Delivery',
    description: 'Order via phone, WhatsApp or online with doorstep delivery and digital receipts.',
    icon: 'truck'
  },
  {
    id: 7,
    title: 'Corporate & Institutions',
    description: 'Supply to hospitals, clinics, nursing homes, NGOs, and workplaces.',
    icon: 'building'
  },
  {
    id: 8,
    title: 'B2B Supply',
    description: 'Bulk pricing and reliable fulfilment for retailers through One Deal Life Science.',
    icon: 'package'
  }
];

export const franchiseFormats = [
  {
    id: 1,
    title: 'FOFO',
    fullForm: 'Franchise Owned, Franchise Operated',
    investment: '₹10-15 Lakhs',
    description: 'Own and operate your pharmacy with complete autonomy and centralized support.',
    benefits: ['Full ownership', 'Operational control', 'Central procurement', 'Training & support']
  },
  {
    id: 2,
    title: 'FICO',
    fullForm: 'Franchise Invested, Company Operated',
    investment: '₹15-20 Lakhs',
    description: 'Invest and earn returns while we handle daily operations with minimum guarantee.',
    benefits: ['Passive income', 'Company managed', 'Minimum guarantee', 'Regular audits']
  },
  {
    id: 3,
    title: 'COCO',
    fullForm: 'Company Owned, Company Operated',
    investment: '₹20-25 Lakhs',
    description: 'Premium flagship stores fully owned and operated by Care Pharmacy.',
    benefits: ['Premium locations', 'Full support', 'Brand standards', 'High ROI potential']
  }
];

export const careers = [
  {
    id: 1,
    title: 'Pharmacist',
    department: 'Operations',
    locations: ['Ahmedabad', 'Mumbai', 'Delhi', 'Pune'],
    description: 'Licensed pharmacists to provide professional guidance and ensure compliance.'
  },
  {
    id: 2,
    title: 'Store Manager',
    department: 'Retail',
    locations: ['Multiple Cities'],
    description: 'Lead store operations, team management, and customer experience excellence.'
  },
  {
    id: 3,
    title: 'Supply Chain Executive',
    department: 'Logistics',
    locations: ['Ahmedabad'],
    description: 'Manage inventory, procurement, and distribution across our growing network.'
  },
  {
    id: 4,
    title: 'Quality Assurance Officer',
    department: 'Quality',
    locations: ['Ahmedabad'],
    description: 'Ensure product quality, regulatory compliance, and safety standards.'
  },
  {
    id: 5,
    title: 'Marketing Manager',
    department: 'Marketing',
    locations: ['Ahmedabad', 'Mumbai'],
    description: 'Drive brand campaigns, digital marketing, and customer engagement initiatives.'
  },
  {
    id: 6,
    title: 'Software Developer',
    department: 'Technology',
    locations: ['Ahmedabad'],
    description: 'Build and maintain our digital platform, automation tools, and customer applications.'
  }
];

export const groupCompanies = [
  {
    id: 1,
    name: 'Care Pharmacy Pvt. Ltd.',
    description: 'Retail pharmacy chain with 190+ stores offering one-roof healthcare solutions.',
    focus: 'Retail Healthcare'
  },
  {
    id: 2,
    name: 'One Deal Life Science Pvt. Ltd.',
    description: 'B2B pharma supply platform providing bulk medicines to retailers across India.',
    focus: 'B2B Distribution'
  },
  {
    id: 3,
    name: 'Quickint Solution Pvt. Ltd.',
    description: 'Pickora robotic automation for automated medicine picking and warehouse management.',
    focus: 'Pharmacy Automation'
  },
  {
    id: 4,
    name: 'Harikrishna Medical Agency',
    description: 'Direct stockist operations ensuring seamless medicine supply chain.',
    focus: 'Stockist Operations'
  },
  {
    id: 5,
    name: 'CurePath International Pvt. Ltd.',
    description: 'Pharmaceutical export company serving global markets with quality medicines.',
    focus: 'Pharma Export',
    website: 'www.curepath.co'
  }
];

export const faqServices = [
  {
    question: 'What types of medicines are available at Care Pharmacy?',
    answer: 'We stock over 35,000 SKUs, including branded, generic, OTC, imported, and specialty medicines, plus surgical, baby care, wellness and FMCG products.'
  },
  {
    question: 'Does Care Pharmacy provide home delivery?',
    answer: 'Yes. Customers can order via phone, website or WhatsApp and receive doorstep delivery with digital receipts at select locations across India.'
  },
  {
    question: 'Can I get lab tests or diagnostic services through Care Pharmacy?',
    answer: "Absolutely. We've partnered with leading diagnostic providers like Dr. Lal Path, Metropolis, and Sterling Accuris for sample collection directly from select stores or your home."
  },
  {
    question: 'Is a doctor consultation available at Care Pharmacy?',
    answer: 'Many of our flagship stores feature an in-store OPD/Doctor Desk for general consultation and guidance.'
  },
  {
    question: 'Can hospitals and institutions buy in bulk?',
    answer: 'Yes. We supply to hospitals, clinics, NGOs and corporates through our B2B vertical—One Deal Life Science Pvt Ltd.'
  },
  {
    question: 'How can I contact customer service?',
    answer: 'You can call +91-6358585323 or WhatsApp +91-8160510969 for assistance or feedback.'
  }
];

export const faqFranchise = [
  {
    question: 'How much investment is required to open a Care Pharmacy franchise?',
    answer: 'Investment varies by format—FOFO, FICO or COCO—and by location size. Typically, it ranges from ₹10–25 lakhs for FOFO and higher for COCO stores.'
  },
  {
    question: 'What support does Care Pharmacy provide to new franchisees?',
    answer: 'We assist with site selection, layout, central procurement, staff training, marketing kits, audits, and tech integration.'
  },
  {
    question: 'Can investors join without pharmacy experience?',
    answer: 'Yes. Our FICO and COCO models allow pure investors to participate under a minimum-guarantee return structure.'
  },
  {
    question: 'How soon can a new store be launched after agreement?',
    answer: 'Typically within 45–60 days after finalization of site and documentation.'
  },
  {
    question: 'What is the expected ROI timeline?',
    answer: 'Depending on model and location, investors generally achieve ROI within 18–24 months under standard operations.'
  },
  {
    question: 'How can I apply for a franchise?',
    answer: 'Visit www.carepharmacy.co/franchise or contact +91-8200886945 for detailed onboarding.'
  }
];

export const companyValues = [
  { id: 1, title: 'Customer First', description: 'Every decision centers on customer wellbeing and satisfaction.' },
  { id: 2, title: 'Integrity', description: 'Transparent pricing, genuine products, and honest relationships.' },
  { id: 3, title: 'Affordability', description: 'Quality healthcare accessible to every family at fair prices.' },
  { id: 4, title: 'Reliability', description: 'Consistent availability, accurate dispensing, and timely service.' },
  { id: 5, title: 'Innovation', description: 'Embracing technology and automation for better healthcare delivery.' },
  { id: 6, title: 'Speed', description: 'Quick service without compromising on quality or care.' },
  { id: 7, title: 'Respect', description: 'Dignity and empathy in every customer and team interaction.' }
];